import {retryWhen} from 'rxjs/operators';
import {mergeMap, Observable, throwError} from 'rxjs';

export const httpRetryStrategyPipe = (maxRetryAttempts: number) => {

  let retryCount = 0;

  return retryWhen((errors) =>
    errors.pipe(
      mergeMap((error) => {
        if (retryCount < maxRetryAttempts && error['status'] === 500) {
          retryCount++;
          return new Observable((observer) => {
            setTimeout(() => {
              observer.next();
              observer.complete();
            }, 300);
          });
        }
        return throwError(error);
      })
    )
  );
}
